import { StackScreenProps } from "@react-navigation/stack";
import { Stack, View } from "@towersystems/roam-common-native";
import { Card } from "@towersystems/roam-common-native";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { TextButton } from "@towersystems/roam-common-native";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { Switch } from "react-native";

export interface StockManagementSettingsScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "StockManagementSettingsScreen"
  > {}

export const StockManagementSettingsScreen = ({
  navigation,
}: StockManagementSettingsScreenProps) => {
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { stocktakeSendToAddress, automaticallyEmailStockTake } =
    globalSettings;

  return (
    <Page title="Stock Management Settings">
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "stocktakeSendToAddress",
                title: "Automatically Email Stocktake",
                subTitle:
                  "A csv file will be emailed to the destination email when a stocktake is completed",
                componentRight: () => {
                  return (
                    <View>
                      <Switch
                        value={automaticallyEmailStockTake}
                        onValueChange={() => {
                          updateGlobalSettings({
                            automaticallyEmailStockTake:
                              !automaticallyEmailStockTake,
                          }).catch((err) => console.log(err));
                        }}
                      />
                    </View>
                  );
                },
              },

              {
                key: "stockcount_destination_email",
                title: "Stockcount Destination Email",
                componentRight: () => {
                  return (
                    <TextButton
                      onPress={() =>
                        navigation.navigate(
                          "EditStockcountDestinationEmailScreen"
                        )
                      }
                    >
                      {stocktakeSendToAddress ||
                        "Set Stockcount Destination Email"}
                    </TextButton>
                  );
                },
              },
            ]}
          ></FlatActionList>
        </Card>
      </Stack>
    </Page>
  );
};
